import { ReactNode, useRef, useState } from 'react';
import classNames from 'classnames';
import { FiUpload } from '@react-icons/all-files/fi/FiUpload';
import { Modal } from '../Modal';
import { Button } from '../Button';
import { ImageCropper } from './ImageCropper';
import { Controller } from 'react-hook-form';

export function ImageModal(props: {
  className?: string;
  pictureUrl?: string;
  title?: string;
  cropperShape?: 'rect' | 'round';
  name: string;
  isLoading?: boolean;
  adjustableAspectRatio?: boolean;
  centeringControls?: boolean;
  buttonLabel: string;
  label?: string;
  initialValue?: string;
  renderValue?: (value?: string) => ReactNode;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploadedImage, setUploadedImage] = useState<File>();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classNames('flex flex-col w-full', props.className)}>
      {!!props.label && (
        <p className="text-sm mb-1 self-start text-gray-700 font-medium">
          {props.label}
        </p>
      )}
      <Controller
        name={props.name}
        render={({ field: { onChange, value } }) => (
          <div className="p-3 rounded-md border border-gray-300 shadow-sm flex-1  mb-[0.7rem] flex flex-col justify-between">
            {props.renderValue?.(
              value ? URL.createObjectURL(value) : props.initialValue,
            )}
            <div className="w-full sm:w-auto text-sm">
              <Modal
                isOpen={isOpen}
                onDismiss={() => {
                  if (inputRef.current?.value) inputRef.current.value = '';
                  setIsOpen(false);
                  setUploadedImage(undefined);
                }}
                title={props.title}
              >
                <ImageCropper
                  isLoading={props.isLoading}
                  cropperShape={props.cropperShape || 'rect'}
                  uploadedImage={uploadedImage as File}
                  setIsOpen={setIsOpen}
                  handleSubmit={(data) => {
                    onChange(data);
                    setIsOpen(false);
                  }}
                  adjustableAspectRatio={props.adjustableAspectRatio}
                  centeringControls={props.centeringControls}
                />
              </Modal>

              <input
                accept="image/*"
                type="file"
                className="hidden"
                ref={inputRef}
                onChange={(e) => {
                  if (e.target?.files?.[0]) {
                    const file = e.target.files[0];
                    setUploadedImage(file);
                    setIsOpen(true);
                  }
                }}
              />
              <Button
                rightIcon={<FiUpload />}
                type="button"
                variant="outline"
                className="mt-4"
                analyticsProperties={{
                  name: 'Change Profile Picture Started',
                }}
                onClick={() => {
                  if (inputRef.current) {
                    inputRef.current.value = '';
                    inputRef?.current?.click();
                  }
                }}
              >
                {props.buttonLabel}
              </Button>
            </div>
          </div>
        )}
      />
    </div>
  );
}
